import { useState } from 'react';
import { toast } from 'react-toastify';
import { default as FNS } from '../../api';

/**
 * "Salvesta pakkumine PDF-ina": fetches the job's current price offer rendered
 * with the existing offer email template and opens it in the browser's print
 * dialog, where the logistician saves it as a PDF.
 */
function SaveOfferPdf({ id }) {
    const [loading, setLoading] = useState(false);

    async function saveOffer() {
        // Open the window synchronously in the click handler so popup blockers
        // allow it; the content is written in once it arrives.
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            toast.error('Brauser blokeeris PDF-i akna. Palun luba hüpikaknad ja proovi uuesti.');
            return;
        }

        setLoading(true);
        try {
            const { html, title } = await FNS.getOfferHtml(id);

            printWindow.document.open();
            printWindow.document.write(html);
            printWindow.document.close();
            // The title becomes the suggested PDF filename in the print dialog
            printWindow.document.title = title;

            // Chrome drops background colours when printing unless told otherwise,
            // which left the KINNITAN / LOOBUN buttons as plain grey text in the PDF
            const printStyle = printWindow.document.createElement('style');
            printStyle.textContent = `
                @page { margin: 12mm; }
                * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
            `;
            printWindow.document.head.appendChild(printStyle);

            // Let the logo and other images load before the print preview snapshots
            // the page, and hide the ones that fail (e.g. the email builder's social
            // icons) so they don't print as broken-image placeholders
            const hideBroken = (img) => { img.style.display = 'none'; };
            const images = Array.from(printWindow.document.images);
            await Promise.all(images.map(img => {
                if (img.complete) {
                    if (img.naturalWidth === 0) hideBroken(img);
                    return null;
                }
                return new Promise(resolve => {
                    img.addEventListener('load', resolve, { once: true });
                    img.addEventListener('error', () => { hideBroken(img); resolve(); }, { once: true });
                });
            }));

            printWindow.focus();
            printWindow.print();
        } catch (e) {
            printWindow.close();
            toast.error('PDF-i genereerimine ebaõnnestus: ' + (e.cause?.message || e.cause || e.message));
        } finally {
            setLoading(false);
        }
    }

    return (
        <button type="button" onClick={saveOffer} disabled={loading}>
            {loading ? 'Koostan PDF-i...' : 'Salvesta pakkumine PDF-ina'}
        </button>
    );
}

export default SaveOfferPdf;
